export const Production = true;
export const API_DOMAIN = Production
   ? "https://api-chamcong.merchbridge.com"
   : "http://localhost:2023";